var render, staticRenderFns
import script from "./editor-view.vue?vue&type=script&lang=js"
export * from "./editor-view.vue?vue&type=script&lang=js"
import style0 from "./editor-view.vue?vue&type=style&index=0&id=4556a942&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports